import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';

export default function getPersonasFromReadWriteRecipientList(
    readWriteRecipientList: ReadWriteRecipientViewState[]
): FindRecipientPersonaType[] {
    let personaList = [];
    if (readWriteRecipientList) {
        personaList = readWriteRecipientList.map(obj => obj.persona);
    }
    return personaList;
}
